export class AnomalyDataPoint {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "actualValue",
            "baseName": "actualValue",
            "type": "number",
            "format": "double"
        },
        {
            "name": "forecastValue",
            "baseName": "forecastValue",
            "type": "number",
            "format": "double"
        },
        {
            "name": "upperBound",
            "baseName": "upperBound",
            "type": "number",
            "format": "double"
        },
        {
            "name": "lowerBound",
            "baseName": "lowerBound",
            "type": "number",
            "format": "double"
        },
        {
            "name": "isAnomaly",
            "baseName": "isAnomaly",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AnomalyDataPoint.attributeTypeMap;
    }
    constructor() {
    }
}
